class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItems =
        this.closest("custom-cart-items") || this.closest("cart-drawer-items");
      if (event.target.closest(".cart-drawer")) {
        cartItems.updateQuantity(this.dataset.index, 0);
      } else {
        cartItems.updateMainQuantity(this.dataset.index, 0);
      }
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CustomCartItems extends HTMLElement {
  constructor() {
    super();

    this.buttons = this.querySelectorAll("button");
    console.log("javascript loaded");
    //   this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    //   this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
    //     .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener("change", this.debouncedOnChange.bind(this));
    this.buttons.forEach((button) => {
      button.addEventListener("click", this.updateQuantitys.bind(this));
    });
  }

  updateQuantitys(event) {
    event.preventDefault();
    event.stopPropagation();
    let input = event.target
      .closest(".quantity-buttons")
      ?.querySelector("input");
    if (event.target.name === "plus") {
      input.value = Number(input?.value) + 1;
    } else {
      input.value = Number(input?.value) - 1;
    }
    let quantity = input?.value;
    let line = event.target.closest(".cart-item").dataset.productIndex;

    if (event.target.closest(".cart-drawer")) {
      this.updateQuantity(line, quantity);
    } else {
      this.updateMainQuantity(line, quantity);
    }

    //if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute("name")
    );
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: ".slide-cart",
      },
    ];
  }

  getMainSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-contents",
      },
    ];
  }

  updateQuantity(line, quantity, name) {
    //   this.enableLoading(line);
    console.log("updateQuantity ran", line);
    document
      .querySelector(`[data-product-index="${line}"] .loading__spinner`)
      .classList.remove("hidden");
    document
      .querySelector(`[data-product-index="${line}"] .cart-item__price`)
      .classList.add("hidden");
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
        console.log(response.text);
      })
      .then((state) => {
        console.log("then state");
        const parsedState = JSON.parse(state);
        console.log(parsedState);
        if (parsedState.errors) {
          alert(parsedState.errors);
          window.location.reload();
          return;
        }
        this.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector("cart-drawer");
        document.querySelector(".cart-total-count").innerHTML =
          parsedState.item_count;
        let productId =
          document.querySelector("product-info")?.dataset.productId;
        let upsellProducts = "";
        if (
          document
            .querySelector(".upsell-products__wrapper")
            .classList.contains("active")
        ) {
          upsellProducts = document.querySelector(".product-upsell").innerHTML;
        } else {
          if (productId) {
            fetch(
              window.Shopify.routes.root +
                `recommendations/products.json?product_id=${productId}&limit=3&intent=related`
            )
              .then((response) => response.json())
              .then(({ products }) => {
                if (products.length > 0) {
                  fetch("/cart.json")
                    .then((response) => response.json())
                    .then((data) => {
                      console.log(data, "data");
                      let filterProducts = [];
                      data.items.forEach((item) => {
                        filterProducts = products.filter(
                          (element) => element.id !== item.product_id
                        );
                      });
                      let Upsellproducts = "";
                      filterProducts.forEach((product) => {
                        Upsellproducts += `<div
                              class="flex flex-col items-center justify-center gap-4 product-upsell__item">
                              <a href="${product.url}" class="rerender_image flex items-center justify-center overflow-hidden bg-white border-2 border-black rounded-lg item-image shadow-btn-shadow shadow-hover_none">
                              
                              </a>
                              <a
                                href="${product.url}"
                                type="button"
                                class="text-sm text-center link-item link-black hidden">
                                Buy Now
                              </a>
                            </div>`;
                      });
                      if (document.querySelector(".upsell-products-wrapper")) {
                        document.querySelector(
                          ".upsell-products-wrapper"
                        ).innerHTML = Upsellproducts;
                      }
                      filterProducts.forEach((product, index) => {
                        const img = document.createElement("img");
                        // Set the source and alt attributes
                        let imageUrl = `${product.featured_image}?&width=250&height=250`;
                        img.src = imageUrl;
                        img.alt = product.featured_image.alt;
                        // Optionally set other attributes, like width and height
                        document
                          .querySelectorAll(".rerender_image")
                          [index].appendChild(img);
                      });

                      document
                        .querySelector("product-upsell")
                        ?.classList.remove("hidden");
                      document
                        .querySelector(".upsell-products__wrapper")
                        ?.classList.add("active");
                    });
                }
              });
          }
        }

        // this.renderContents(parsedState);
        // const cartFooter = document.getElementById('main-cart-footer');

        // if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper)
          cartDrawerWrapper.classList.toggle(
            "is-empty",
            parsedState.item_count === 0
          );

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace = document.querySelector(
            `${section.selector}`
          );
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.id],
            section.selector
          );
        });

        if (document.querySelector(".empty-button")) {
          let buttonLabel =
            document.querySelector(`[data-button-label]`).dataset.buttonLabel;
          let buttonLink =
            document.querySelector(`[data-button-link]`).dataset.buttonLink;
          document.querySelector(".empty-button").textContent = buttonLabel;
          document.querySelector(".empty-button").href = buttonLink;
          document.querySelector(".cart-total-count").innerHTML =
            parsedState.item_count;
          let body = document.querySelector("body");
          let closeCartBtn = document.querySelector(".close-cart-btn");
          let slideCart = document.querySelector(".slide-cart");
          closeCartBtn.addEventListener("click", function () {
            slideCart.classList.remove("active");
            body.classList.remove("active");
          });
        } else {
          if (upsellProducts) {
            document
              .querySelector(".upsell-products__wrapper")
              .classList.add("active");
            document.querySelector(".product-upsell").innerHTML =
              upsellProducts;
          }
        }

        const slideCartBtn = document.querySelector(".slide-cart-icon");
        const slideCart = document.querySelector(".slide-cart");
        const closeCartBtn = document.querySelector(".close-cart-btn");
        let body = document.querySelector("body");

        closeCartBtn.addEventListener("click", function () {
          slideCart.classList.remove("active");
          body.classList.remove("active");
        });

        let cartPoverlay = document.querySelector(".cart-overlay");

        window.onclick = function (event) {
          console.log(event.target, "event.target ");
          if (event.target == cartPoverlay) {
            slideCart.classList.remove("active");
            body.classList.remove("active");
          }
        };

        // Event listener for pressing the 'ESC' key
        window.onkeydown = function (event) {
          if (event.key === "Escape") {
            // Check if the pressed key is 'ESC'
            slideCart.classList.remove("active");
            body.classList.remove("active");
          }
        };

        closeCartBtn.addEventListener("click", function () {
          slideCart.classList.remove("active");
          body.classList.remove("active");
        });
        this.querySelector(".loading__spinner").classList.add("hidden");
        // this.updateLiveRegions(line, parsedState.item_count);
        // const lineItem =  document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        // if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
        // cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        // } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
        // trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        // } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
        // trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        // }
        // this.disableLoading();
      })
      .catch(() => {
        this.querySelectorAll(".loading-overlay").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        const errors =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
        if (errors) {
          errors.textContent = window.cartStrings.error;
        }
        this.disableLoading();
      });
  }

  updateMainQuantity(line, quantity, name) {
    //   this.enableLoading(line);
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getMainSectionsToRender().map(
        (section) => section.section
      ),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector("cart-drawer");
        document.querySelector(".cart-total-count").innerHTML =
          parsedState.item_count;
        // this.renderContents(parsedState);
        const cartFooter = document.getElementById("main-cart-footer");

        if (cartFooter)
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        if (cartDrawerWrapper)
          cartDrawerWrapper.classList.toggle(
            "is-empty",
            parsedState.item_count === 0
          );

        // this.getMainSectionsToRender().forEach((section => {
        //   console.log(section.selector, 'section.selector');

        //   const elementToReplace = document.getElementById(section.id).querySelector(section.selector);
        //   console.log(elementToReplace, 'elementToReplace');
        //       elementToReplace.innerHTML =
        //   this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        // }));

        this.getMainSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);

          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });

        // this.updateLiveRegions(line, parsedState.item_count);
        // const lineItem =  document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        // if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
        // cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        // } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
        // trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        // } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
        // trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        // }
        // this.disableLoading();
      })
      .catch(() => {
        this.querySelectorAll(".loading-overlay").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        const errors =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
        if (errors) {
          errors.textContent = window.cartStrings.error;
        }
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError =
        document.getElementById(`Line-item-error-${line}`) ||
        document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement =
        document.getElementById(`Quantity-${line}`) ||
        document.getElementById(`Drawer-quantity-${line}`);

      lineItemError.querySelector(".cart-item__error-text").innerHTML =
        window.cartStrings.quantityError.replace(
          "[quantity]",
          quantityElement.value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.add("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading-overlay`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading-overlay`
    );

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove("hidden")
    );

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading() {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    if (mainCartItems) {
      mainCartItems.classList.remove("cart__items--disabled");
    }
  }
}

customElements.define("custom-cart-items", CustomCartItems);

class PopupSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.input.addEventListener("keyup", this.onKeyup.bind(this));
  }

  onKeyup(event) {
    if (event.code == "Enter") {
      this.search();
    }
  }

  search() {
    let query = this.input.value;
    console.log(query, "query");
    this.closest(".popup-searh-wrapper")
      .querySelector(".loading-overlay")
      ?.classList.add("active");
    this.closest(".popup-searh-wrapper")
      .querySelector(".loading__spinner")
      ?.classList.remove("hidden");
    // Fetch search results
    fetch(`/search?q=${encodeURIComponent(query)}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.text(); // or response.json() if the response is in JSON format
      })
      .then((data) => {
        // Process the HTML or JSON data
        //console.log(data, 'data'); // You can manipulate the DOM or display results here
        const parser = new DOMParser();
        const doc = parser.parseFromString(data, "text/html"); // Parse the HTML string
        if (doc.querySelector("#ProductGridContainer")) {
          let searchResults = doc.querySelector("#ProductGridContainer");
          this.closest(".popup-searh-wrapper").querySelector(
            ".search_results"
          ).innerHTML = searchResults.innerHTML;
          const SeachItem = this.closest(
            ".popup-searh-wrapper"
          ).querySelectorAll(".item-wrapper .item-title");
          this.closest(".popup-searh-wrapper")
            .querySelector(".search_results")
            .classList.remove("hidden");
          SeachItem.forEach((element) => {
            element.classList.remove("active");
          });
          this.closest(".popup-searh-wrapper")
            .querySelector(".contents-wrapper")
            .classList.add("hidden");
          this.closest(".popup-searh-wrapper")
            .querySelector(".search_results")
            .classList.remove("hidden");
          this.closest(".popup-searh-wrapper")
            .querySelector(".popup-empty-wrapper")
            .classList.add("hidden");
        } else {
          const SeachItem = this.closest(
            ".popup-searh-wrapper"
          ).querySelectorAll(".item-wrapper .item-title");
          SeachItem.forEach((element) => {
            element.classList.remove("active");
          });
          this.closest(".popup-searh-wrapper")
            .querySelector(".contents-wrapper")
            .classList.add("hidden");
          this.closest(".popup-searh-wrapper")
            .querySelector(".search_results")
            .classList.add("hidden");
          let emptyText = doc.querySelector(".empty-texts");
          if (emptyText) {
            this.closest(".popup-searh-wrapper").querySelector(
              ".popup-empty-text"
            ).innerHTML = emptyText.innerHTML;
          }
        }
        this.closest(".popup-searh-wrapper")
          .querySelector(".loading-overlay")
          .classList.remove("active");
        this.closest(".popup-searh-wrapper")
          .querySelector(".loading__spinner")
          .classList.add("hidden");
      })
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error
        );
      });
  }
}

customElements.define("popup-search", PopupSearch);

class CollectionSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.input.addEventListener("keyup", this.onKeyup.bind(this));
    this.allProducts = null; // Will store all products from all pages
    this.isLoadingProducts = false;
    this.loadAllProducts(); // Start loading all products when component initializes
  }

  loadAllProducts() {
    if (this.isLoadingProducts || this.allProducts) return;
    
    this.isLoadingProducts = true;
    this.allProducts = [];

    // First, fetch page 1 to determine how many total pages we need
    const firstPageUrl = window.location.pathname + window.location.search;
    
    fetch(firstPageUrl)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        // Extract products from page 1
        const productCards = doc.querySelectorAll("#product-grid .product-card-animation");
        const productsPerPage = productCards.length;
        
        // Store page 1 products
        productCards.forEach(card => {
          const titleElement = card.querySelector(".character-product__title");
          if (titleElement) {
            this.allProducts.push({
              element: card.cloneNode(true),
              title: titleElement.textContent
                .trim()
                .replace(/[^a-zA-Z0-9\s]/g, "")
                .toLowerCase()
            });
          }
        });

        // Check if there's pagination info to determine total pages
        const paginationLinks = doc.querySelectorAll("a[href*='page=']");
        let maxPage = 1;
        
        paginationLinks.forEach(link => {
          const match = link.href.match(/[?&]page=(\d+)/);
          if (match) {
            maxPage = Math.max(maxPage, parseInt(match[1]));
          }
        });


        // If there are more pages, load them all in parallel
        if (maxPage > 1) {
          const pagePromises = [];
          
          for (let page = 2; page <= maxPage; page++) {
            const url = window.location.pathname;
            const urlParams = new URLSearchParams(window.location.search);
            urlParams.set('page', page);
            const pageUrl = url + '?' + urlParams.toString();
            
            const promise = fetch(pageUrl)
              .then(response => response.text())
              .then(html => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                const cards = doc.querySelectorAll("#product-grid .product-card-animation");
                
                
                return Array.from(cards).map(card => {
                  const titleElement = card.querySelector(".character-product__title");
                  if (titleElement) {
                    return {
                      element: card.cloneNode(true),
                      title: titleElement.textContent
                        .trim()
                        .replace(/[^a-zA-Z0-9\s]/g, "")
                        .toLowerCase()
                    };
                  }
                  return null;
                }).filter(p => p !== null);
              })
              .catch(error => {
                return [];
              });
            
            pagePromises.push(promise);
          }

          // Wait for all pages to load, then combine results
          Promise.all(pagePromises).then(results => {
            results.forEach(pageProducts => {
              this.allProducts.push(...pageProducts);
            });
            
            this.isLoadingProducts = false;
          });
        } else {
          this.isLoadingProducts = false;
        }
      })
      .catch(error => {
        this.isLoadingProducts = false;
      });
  }

  onKeyup(event) {
    this.search();
  }

  search() {
    const query = this.input.value
      .toLowerCase()
      .replace(/[^a-zA-Z0-9\s]/g, "");
    
    const productGrid = document.querySelector("#product-grid");
    if (!productGrid) return;

    // If products haven't finished loading yet, try again in a moment
    if (!this.allProducts) {
      setTimeout(() => this.search(), 100);
      return;
    }

    // If query is empty, show all products
    if (query.trim() === "") {
      productGrid.innerHTML = "";
      this.allProducts.forEach(product => {
        productGrid.appendChild(product.element.cloneNode(true));
      });
      return;
    }

    // Filter products based on search query
    const filteredProducts = this.allProducts.filter(product => 
      product.title.includes(query)
    );

    // Update grid with filtered results
    productGrid.innerHTML = "";
    
    if (filteredProducts.length > 0) {
      filteredProducts.forEach(product => {
        productGrid.appendChild(product.element.cloneNode(true));
      });
    } else {
      // Show "no results" message
      const noResults = document.createElement("li");
      noResults.style.gridColumn = "1/-1";
      noResults.style.textAlign = "center";
      noResults.style.padding = "2rem";
      noResults.textContent = "No products found";
      productGrid.appendChild(noResults);
    }
  }
}

customElements.define("collection-search", CollectionSearch);

class SeachItem extends HTMLElement {
  constructor() {
    super();
    this.items = this.querySelectorAll(".item-wrapper .item-title");
    this.contents = this.querySelectorAll(".contents-wrapper .contents-item");
    this.items.forEach((item) => {
      item.addEventListener("click", this.onchange.bind(this));
    });
  }

  onchange(event) {
    let currentItem = event.target;
    let itemTitle = currentItem.dataset.itemTitle;
    this.items.forEach((element) => {
      element.classList.remove("active");
    });
    currentItem.classList.add("active");
    this.contents.forEach((content) => {
      content.classList.add("hidden");
    });
    this.querySelector(`[data-item-content="${itemTitle}"]`).classList.remove(
      "hidden"
    );
    this.querySelector(".contents-wrapper").classList.remove("hidden");
    this.querySelector(".search_results").classList.add("hidden");
    this.querySelector(".popup-empty-wrapper").innerHTML = "";
  }
}

customElements.define("search-item", SeachItem);

window.onload = function (event) {
  if (window.location.href.includes("?open-cart=true")) {
    let slideCart = document.querySelector(".slide-cart");
    slideCart.classList.add("active");
  }
};

window.addEventListener("scroll", function () {
  let scrollTop = window.scrollY;
  if (scrollTop > 75) {
    if (document.querySelector(".homepage-index")) {
      document.querySelector(".homepage-index").classList.add("bg-nav-pattern");
      document.querySelector(".homepage-index").classList.add("bg-scheme-bg");
      document.querySelector(".homepage-index").classList.add("custom-border");
    }
  } else {
    document
      .querySelector(".homepage-index")
      .classList.remove("bg-nav-pattern");
    document.querySelector(".homepage-index").classList.remove("bg-scheme-bg");
    document.querySelector(".homepage-index").classList.remove("custom-border");
  }
});

document.querySelector(".view_details")?.addEventListener("click", function () {
  document.querySelector(".vf-accordian")?.scrollIntoView({
    behavior: "smooth",
  });
});

// MegaMenu Dropdown
//   const shopItemBtn = document.querySelector('.shop-item-btn');
//   const shopItemContent = document.querySelector('.shop-items');
//   const shopCharBtn = document.querySelector('.shop-character-btn');
//   const shopCharContent = document.querySelector('.shop-character');
//   const navHeader = document.querySelector('.header');

//   shopItemBtn.addEventListener('click', function () {
//     this.classList.toggle('active');
//     shopItemContent.classList.toggle('active');

//     if (shopItemBtn.classList.contains('active')) {
//       navHeader.classList.add('has-bg');
//     } else {
//       navHeader.classList.remove('has-bg');
//     }

//     shopCharBtn.classList.remove('active');
//     shopCharContent.classList.remove('active');
//   });

//   shopCharBtn.addEventListener('click', function () {
//     this.classList.toggle('active');
//     shopCharContent.classList.toggle('active');

//     if (shopCharBtn.classList.contains('active')) {
//       navHeader.classList.add('has-bg');
//     } else {
//       navHeader.classList.remove('has-bg');
//     }

//     shopItemBtn.classList.remove('active');
//     shopItemContent.classList.remove('active');
//   });

// MegaMenu tabs
//   const buttonElement = document.querySelectorAll('.character-btn');
//   const tabContent = document.querySelectorAll('.shopCharacter-content');

//   tabContent[0].style.display = 'block';

//   buttonElement.forEach(function (btn) {
//     btn.addEventListener('click', function (event) {
//       for (let x = 0; x < buttonElement.length; x++) {
//         if (event.target.id == buttonElement[x].id) {
//           buttonElement[x].className = buttonElement[x].className.replace(' active', '');
//           tabContent[x].style.display = 'block';
//           event.currentTarget.className += ' active';
//         } else {
//           tabContent[x].style.display = 'none';
//           buttonElement[x].className = buttonElement[x].className.replace(' active', '');
//         }
//       }
//     });
//   });

//mobile tab buttons
const itemMobileBtn = document.querySelector(".item-mobile-btn");
const itemMobileContent = document.querySelector(".item-mobile-content");

const characterMobileBtn = document.querySelector(".character-mobile-btn");
const characterMobileContent = document.querySelector(
  ".character-mobile-content"
);

itemMobileBtn.addEventListener("click", function () {
  this.classList.add("active");
  itemMobileContent.classList.add("active");

  characterMobileBtn.classList.remove("active");
  characterMobileContent.classList.remove("active");
});

characterMobileBtn.addEventListener("click", function () {
  this.classList.add("active");
  characterMobileContent.classList.add("active");

  itemMobileBtn.classList.remove("active");
  itemMobileContent.classList.remove("active");
});

//Mobile menu dropdown
const dropdownMenu = document.querySelectorAll(".item-dropdown");
const dropdownMenuUl = document.querySelector(".item-dropdown-main");

dropdownMenu.forEach((dropdown) => {
  const btn = dropdown.querySelector(".dropdown-toggle-mobile");
  const ul = dropdown.parentElement;

  btn.addEventListener("click", () => {
    dropdownMenu.forEach((item) => {
      if (item !== dropdown) {
        item.classList.remove("open");
      }
    });
    dropdown.classList.toggle("open");
    ul.classList.toggle("active");
  });
});

//Mobile Menu toggle
const mobileToggler = document.querySelector(".mobile-menu-toggle");
const mobileMenu = document.querySelector(".mobile-menu");
const header = document.querySelector(".header");

mobileToggler.addEventListener("click", function () {
  mobileToggler.classList.toggle("active");
  header.classList.toggle("z_index");
  header.classList.toggle("bg-green");

  if (!document.querySelector(".white-logo").classList.contains("hidden")) {
    setTimeout(() => {
      document.querySelector(".green-logo").classList.toggle("hidden");
      document.querySelector(".white-logo").classList.toggle("hidden");
    }, 500);
  } else {
    document.querySelector(".green-logo").classList.toggle("hidden");
    document.querySelector(".white-logo").classList.toggle("hidden");
  }

  if (header.classList.contains("bg-nav-pattern")) {
    header.classList.toggle("custom-border");
  }
  mobileMenu.classList.toggle("active");

  document.querySelector("sticky-header").classList.toggle("enable_scroll");

  if (
    document.querySelector(".js-search-content").classList.contains("active")
  ) {
    document.querySelector(".js-search-content").classList.remove("active");
    document
      .querySelector(".js-search-btn .icon-search")
      .classList.remove("hidden");
    document
      .querySelector(".js-search-btn .icon-close")
      .classList.add("hidden");
    document.querySelector(".header-wrapper").classList.remove("h-dvh");
    document.querySelector("main").classList.remove("hidden");
    document.querySelector(".js-search-btn").classList.remove("active");
    document
      .querySelector(".js-search-btn")
      .setAttribute("aria-expanded", "false");
  }

  if (mobileMenu.classList.contains("active")) {
    document.querySelector("body").classList.add("overflow-hidden");
    document.querySelector(".html-wrapper").classList.add("overflow-hidden");
  } else {
    document.querySelector("body").classList.remove("overflow-hidden");
    document.querySelector(".html-wrapper").classList.remove("overflow-hidden");
  }

  // if (mobileToggler.classList.contains('active')) {
  //   navHeader.classList.add('has-bg');
  // } else {
  //   navHeader.classList.remove('has-bg');
  // }
});

window.onclick = function (event) {
  console.log(event.target, "event.target");
  if (
    (event.target == mobileMenu && event.target.classList.contains("active")) ||
    event.target.closest(".mobile-menu").classList.contains("active")
  ) {
    header.classList.remove("z_index");
    header.classList.remove("bg-green");
    setTimeout(() => {
      document.querySelector(".green-logo").classList.add("hidden");
      document.querySelector(".white-logo").classList.remove("hidden");
    }, 500);
    mobileToggler.classList.remove("active");
    mobileMenu.classList.remove("active");
    document.querySelector("body").classList.remove("overflow-hidden");
    document.querySelector(".html-wrapper").classList.remove("overflow-hidden");
    document.querySelector("sticky-header").classList.add("enable_scroll");
  }
};

// Event listener for pressing the 'ESC' key

// const productCards = document.querySelectorAll('.product-card-animation');
// const productContainer = document.querySelector('#product-grid'); // Adjust this selector as needed

// gsap.registerPlugin(ScrollTrigger);

// // Create a timeline for all cards
// const scaleAnimation = gsap.timeline({
//   scrollTrigger: {
//     trigger: productContainer, // Use the parent container as the trigger
//     start: "top 80%", // When the top of the container hits 80% of the viewport height
//     end: "top 20%", // End when the top of the container hits 20% of the viewport height
//     toggleActions: "play none none reverse"
//   }
// });

// // Define the growing animation for all product cards
// scaleAnimation.fromTo(productCards,
//   {
//     scale: 0.6, // Start smaller
//     opacity: 0 // Start hidden
//   },
//   {
//     scale: 1, // End at normal size
//     opacity: 1, // Fade in
//     duration: 0.5, // Duration for the animation
//     ease: "power2.out",
//     stagger: 0.1 // Stagger the animations for a smooth effect
//   }
// );

document.querySelectorAll(".range-input").forEach((element) => {
  let rangeInput = element.querySelectorAll("input"),
    priceInput = element
      .closest(".price-range__wrapper")
      .querySelectorAll(".price-input input"),
    range = element
      .closest(".price-range__wrapper")
      .querySelector(".slider .progress");
  let priceGap = 5;

  priceInput.forEach((input) => {
    input.addEventListener("input", (e) => {
      let minPrice = parseInt(priceInput[0].value),
        maxPrice = parseInt(priceInput[1].value);

      if (maxPrice - minPrice >= priceGap && maxPrice <= rangeInput[1].max) {
        if (e.target.className === "input-min") {
          rangeInput[0].value = minPrice;
          range.style.left = (minPrice / rangeInput[0].max) * 100 + "%";
        } else {
          rangeInput[1].value = maxPrice;
          range.style.right = 100 - (maxPrice / rangeInput[1].max) * 100 + "%";
        }
      }
    });
  });

  rangeInput.forEach((input) => {
    input.addEventListener("input", (e) => {
      let minVal = parseInt(rangeInput[0].value),
        maxVal = parseInt(rangeInput[1].value);

      if (maxVal - minVal < priceGap) {
        if (e.target.className === "range-min") {
          rangeInput[0].value = maxVal - priceGap;
        } else {
          rangeInput[1].value = minVal + priceGap;
        }
      } else {
        priceInput[0].value = minVal;
        priceInput[1].value = maxVal;
        range.style.left = (minVal / rangeInput[0].max) * 100 + "%";
        range.style.right = 100 - (maxVal / rangeInput[1].max) * 100 + "%";
      }
    });
  });
});
